// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ujelyhixskhxmjqtrqxk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVqZWx5aGl4c2toeG1qcXRycXhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkzNDMzODEsImV4cCI6MjA1NDkxOTM4MX0.w3L4HwVituLCWL9ror6lqZdcrOJFhsBqi7yetiOkhj0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);